import React from "react";
import TeamSIngleBlog from "../../../../components/TeamSIngleBlogTwo/TeamSIngleBlogTwo";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/css/pagination";

SwiperCore.use([Navigation, Pagination]);

const HomeTwoBlogsTwo = () => {
  return (
    <>
      <section
        className="tp-blog-area-two pt-50 pb-50 pl-20 pr-20"
        style={{ background: "#39B54A" }}
      >
        <div className="">
          <div className="row">
            <div className="tp-testimonial-two-active swiper-container common-dots pb-10">
              <Swiper
                spaceBetween={30}
                slidesPerView={1}
                style={{ paddingBottom: "10px" }}
                className="swiper-wrapper"
                pagination={{ clickable: true }}
                autoplay={{ delay: 6000 }}
                breakpoints={{
                  550: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 1,
                  },
                  992: {
                    slidesPerView: 3,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                }}
                navigation={{
                  nextEl: ".service-button-next",
                  prevEl: ".service-button-prev",
                }}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
              >
                <SwiperSlide>
                  <div className="col-lg-12 col-md-12">
                    <div
                      className="tp-blog-two mb-10 position-relative wow fadeInUp"
                      data-wow-delay=".3s"
                    >
                      <div
                        className="tp-blog-text-top-two "
                        style={{ borderRadius: "10px" }}
                      >
                        <img
                          src={`assets/img/blog/Tray1/11.png`}
                          className="img-fluid tp-blog-image-width"
                          alt="img not found"
                          style={{ borderRadius: "10px" }}
                        />
                        <p className="mt-30 mb-20">
                          <b>
                            Celebrating the growth journeys and resilience of
                            our customers
                          </b>
                        </p>
                        <div className="tp-header-btn-three">
                          <Link
                            to="/winners-business-champion"
                            className="yellow-btn"
                            style={{ borderRadius: "10px" }}
                          >
                            Winners 2022
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="col-lg-12 col-md-12">
                    <div
                      className="tp-blog-two mb-10 position-relative wow fadeInUp"
                      data-wow-delay=".3s"
                    >
                      <div
                        className="tp-blog-text-top-two "
                        style={{ borderRadius: "10px" }}
                      >
                        <img
                          src={`assets/img/blog/Tray1/12.png`}
                          className="img-fluid tp-blog-image-width"
                          alt="img not found"
                          style={{ borderRadius: "10px" }}
                        />
                        <p className="mt-30 mb-20">
                          <b>
                            Recognizing the Younite Partners, who exhibit strong
                            business acumen and commitment
                          </b>
                        </p>
                        <div className="tp-header-btn-three">
                          <Link
                            to="/winners-stalwart"
                            className="yellow-btn"
                            style={{ borderRadius: "10px" }}
                          >
                            Winners 2022
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="col-lg-12 col-md-12">
                    <div
                      className="tp-blog-two mb-10 position-relative wow fadeInUp"
                      data-wow-delay=".3s"
                    >
                      <div
                        className="tp-blog-text-top-two "
                        style={{ borderRadius: "10px" }}
                      >
                        <img
                          src={`assets/img/blog/Tray1/13.png`}
                          className="img-fluid tp-blog-image-width-two"
                          alt="img not found"
                          style={{ borderRadius: "10px" }}
                        />
                        <p className="mt-30 mb-20">
                          <b>
                            Felicitating the 40 brightest Younite Partners with
                            promising business growth potential
                          </b>
                        </p>
                        <div className="tp-header-btn-three">
                          <Link
                            to="/winners-forty-under-forty"
                            className="yellow-btn"
                            style={{ borderRadius: "10px" }}
                          >
                            Winners 2022
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="swiper-pagination-testimonial slide-dots "></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeTwoBlogsTwo;
